/*
 * Purpose : Declare tools view page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, { Component } from 'react'
import { AiFillFilePdf } from "react-icons/ai"
import { Button, Alert, Modal, ModalBody, Col, Input, Row, ModalHeader, ModalFooter } from 'reactstrap'
import axios from 'axios'

import { errorConstants, htmlConstants, successConstants, headerMapping, rowMapping } from '../../config/constants';
import ViewTable from './ViewTable/ViewTable';
import { GetFileDataService } from './../../services/GetFileDataService';
import { PostFormService } from './../../services/PostFormDataService';
import LoadingModal from '../../components/UI/modals/loadingModal';
import AppContext from "../../context/app-context";
import BackButton from "../UI/Buttons/BackButton/BackButton"

//pdf configuration
import arraybuffbase64 from 'base64-arraybuffer';
import pdfmake from 'pdfmake/build/pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";
import xlsx from 'xlsx';
import { PDFDocument } from 'pdf-lib';
import ToolSalesButton from '../UI/Buttons/ToolSalesButton/ToolSalesButton';
import { sectionHeader } from 'aws-amplify';

pdfmake.vfs = pdfFonts.pdfMake.vfs;

const postform = new PostFormService();
const getFileData = new GetFileDataService();


export default class ViewForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            error: false,
            errorMsg: "",
            success: false,
            readOnly: false,
            loading: false,
            reject: false,
            rejectreason: false,
            rejectreasonText: "",
            remarks: [],
            currentUser: "",
            viewDataDeails: {},
            isReviewer: 0,
            reassign: false,
            reassignEmail: "",
            reassignEmailError: ""
        }
        this.transactionid = this.props.match.params.transid
        this.initiator = ""
        this.toolid = ""
        this.rejectReason = ""

        this.buildComponent = this.buildComponent.bind(this)
        this.submitResponse = this.submitResponse.bind(this)
        this.resetComponent = this.resetComponent.bind(this)
        this.setRejectReason = this.setRejectReason.bind(this)
        this.exportPDF = this.exportPDF.bind(this)
        this.submitReassign = this.submitReassign.bind(this)
    }
    static contextType = AppContext;
    async componentDidMount() {
        try {
            if (!this.transactionid) {
                throw new Error("Transaction ID not defined. Please provide transaction id in the URL")
            }
            this.setState({ loading: true })
            this.setState({
                //console.log("user in view =>",this.context.user.toLowerCase())
                currentUser: this.context.user.toLowerCase()
            })
            console.log("view role =>", this.context.role)
            await getFileData.getSavedData(this.transactionid).then(viewDataDeails => {
                viewDataDeails.reviewer = (this.context.role === "Admin" || this.context.role === "Reviewer") ? 1 : 0;
                const isReviewer = (this.context.role === "Admin" || this.context.role === "Reviewer") ? 1 : 0;
                this.setState({
                    viewDataDeails: viewDataDeails,
                    isReviewer: isReviewer
                })
                //this.viewDataDeails = viewDataDeails
                this.buildComponent(viewDataDeails)
            }
            )
            // old approach without using appcontext
            // await getFileData.getSavedData(this.transactionid).then( viewDataDeails => 
            //     {
            //         viewDataDeails.reviewer = (this.props.match.params.role==="Admin" || this.props.match.params.role==="Reviewer")?1:0;
            //         const isReviewer = (this.props.match.params.role==="Admin" || this.props.match.params.role==="Reviewer")?1:0;
            //         this.setState({
            //             viewDataDeails:viewDataDeails,
            //             isReviewer:isReviewer                                              
            //         })
            //         //this.viewDataDeails = viewDataDeails
            //         this.buildComponent(viewDataDeails)
            //     }
            // )
            //this.buildComponent(viewData);
        }
        catch (err) {
            const reqBody = {
                level: "error",
                message: "Error while fetching saved data for view. error: " + err
            }
            axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );
            this.setState({
                error: true,
                errorMsg: errorConstants.errorloading,
                loading: false
            })
        }
    }

    buildComponent = (data) => {
        try {
            let readOnly = false
            if (!data) {
                throw new Error("Error fetching form data")
            }
            console.log("data.transaction[0].Initiator==>", data.transaction)
            delete data.transaction[0].txnuniquesutlid // not to show in view
            delete data.transaction[0].txn_assets_mgt_status // not to show in view
            this.initiator = data.transaction[0].initiator
            this.toolid = data.transaction[0].toolid
            this.rejectReason = data.transaction[0].reviewerremarks
            // Frame previous reviewer remarks text
            let remarks = []
            //console.log("this.rejectReason==>",this.rejectReason)
            if (this.rejectReason && this.rejectReason !== "null") {
                remarks.push(<b>Previous reviewer remarks</b>)
                this.rejectReason.split('|||').forEach(reason => {
                    if (reason !== null && reason !== "null") {
                        remarks.push(
                            <div>
                                <i>{reason}</i><br />
                                <hr />
                            </div>
                        )
                    }
                })
            }
            const items = []
            // split config files from photos section..
            if (data.photos) {
                data.configfiles = [...data.photos].filter((el, i) => {
                    if (el.systemtype === "configfiles") {
                        return el
                    }
                })
            }
            const reviewer = data.reviewer
            delete data.reviewer
            Object.keys(data).forEach((set, index) => {
                items.push(<ViewTable header={set} data={data[set]} key={index} />)
            })
            //console.log("reviewer=>",reviewer)
            //console.log("approved=>",data.transaction[0][0].fabsection)
            if (data.transaction[0].approved.trim().toUpperCase() === "NO") {
                data.transaction[0].approved = htmlConstants.approvalpending
                if (reviewer === 1) {
                    items.push(
                        <div className={"view-buttons"}>
                            <Button style={{ margin: "10px" }} color="success" value="APPROVED" onClick={this.submitResponse}>Approve</Button>
                            <Button style={{ margin: "10px" }} color="danger" value="REJECTED" onClick={this.submitResponse}>Reject</Button>
                        </div>
                    )
                }
                else {
                    readOnly = true
                }
            }
            else {
                readOnly = true
            }
            data.transaction[0].reviewerremarks = remarks
            this.setState({
                items,
                remarks,
                readOnly,
                loading: false
            })
        }
        catch (err) {
            const reqBody = {
                level: "error",
                message: "Error while forming view data for view. error: " + JSON.stringify(err)
            }
            axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );

            this.setState({
                error: true,
                errorMsg: err,
                loading: false
            })
        }
    }
    submitResponse = (e) => {
        try {
            if (e.target.value.toLowerCase().trim() === "rejected") {
                this.setState({ reject: true, rejectreason: true })
            }
            else {
                this.postResponse(e)
            }
        }
        catch (err) {
            this.setState({
                error: true,
                errorMsg: err,
                loading: false
            })
        }
    }
    submitRejectResponse = (e) => {
        if (!this.state.rejectreason) {
            this.postResponse(e)
        }
    }
    setRejectReason = (e) => {
        if (e.target.value) {

            this.setState({
                rejectreason: false,
                rejectreasonText: `${this.rejectReason}|||${e.target.value}`
            })
        }
    }
    postResponse = async (e) => {
        this.setState({ loading: true, reject: false }) //uncomment
        //console.log("this.currentUser new ==>",this.state.currentUser)
        //console.log("this.initiator=>",this.initiator)
        const resultCode = await postform.updateTransaction(this.transactionid, this.toolid, e.target.value, this.state.currentUser, this.state.rejectreasonText, this.initiator)
        console.log("resultCode=>", resultCode)
        if (resultCode === 200) {
            //logging info
            let message = null;
            if (this.state.rejectreasonText === "" || this.state.rejectreasonText == null) {
                message = "Form is Approved. User : " + this.state.currentUser + " , transactionid : " + this.transactionid + " , toolid : " + this.toolid
            }
            else {
                message = "Form is Rejected. User : " + this.state.currentUser + " , transactionid : " + this.transactionid + " , toolid : " + this.toolid
            }
            const reqBody = {
                level: "info",
                message: message
            }
            await axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );
            this.setState({ success: true, loading: false })

        } else {
            const reqBody = {
                level: "error",
                message: "Approval or Rejection is failed. transactionid : " + this.transactionid + " , toolid : " + this.toolid
            }
            await axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );
            this.setState({
                error: true,
                errorMsg: errorConstants.serverreqfailed,
                loading: false
            })
            throw Error("Error while Updating transaction details")
        };
    }
    submitReassign = async (e) => {
        try {
            if (this.state.reassignEmail) {
                this.setState({ loading: true, reassign: false })
                const resultCode = await postform.updateInitiator(this.transactionid, this.toolid, this.state.reassignEmail, this.state.currentUser)
                console.log("resultCode=>", resultCode)
                if (resultCode === 200) {
                    //logging info
                    let message = "Transaction is Reassigned."

                    const reqBody = {
                        level: "info",
                        message: message
                    }

                    await axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                        reqBody,
                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                    );
                    this.setState({ reassignSuccess: true, loading: false })

                } else {
                    const reqBody = {
                        level: "error",
                        message: "Error in reassigning the transaction.!"
                    }
                    await axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                        reqBody,
                        { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
                    );
                    throw Error("Error while Reassigning the transaction")
                };
            }
            else {
                this.setState({
                    reassignEmailError: "Enter Valid Email"
                })
            }
        }
        catch (err) {
            this.setState({
                error: true,
                errorMsg: err,
                loading: false
            })
        }
    }

    setReassignEmail = (e) => {
        const validEmailRegex = RegExp(
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        );
        if (e.target.value) {
            if (validEmailRegex.test(e.target.value)) {
                this.setState({
                    reassignEmail: e.target.value,
                    reassignEmailError: ""
                })
            } else {
                this.setState({
                    reassignEmailError: "Enter Valid Email"
                })
            }
        }
    }

    resetComponent = () => {
        this.setState({ success: false })
        window.location.reload()
    }



    exportPDF = async () => {

        // eslint-disable-next-line no-restricted-globals
        const userSelection = confirm("PDF will be downloaded. It make take a few moments if transaction has more/large files");
        //console.log("userSelection",userSelection)
        if (!userSelection) {
            return;
        }
        //console.log("not returned")

        this.setState({ loading: true })
        //delete this.state.viewDataDeails.configfiles[0].toolpicture
        //console.log("this.state.viewDataDeails=>",this.state.viewDataDeails)
        try {
            const buffList = []
            const data = this.state.viewDataDeails;
            if (data.transaction) {
                data.transaction = data.transaction.map(el => {
                    delete el.transactionid
                    delete el.approved
                    delete el.initiator
                    delete el.reviewer
                    delete el.reviewerremarks
                    delete el.transactiontype
                    delete el.date
                    delete el.txnfab
                    delete el.txnmodule
                    delete el.txnuemseqptid
                    delete el.txnuniquesutlid
                    delete el.txn_assets_mgt_status

                    return el
                })
            }
            // split config files from photos section..
            if (data.photos) {
                data.configfiles = [...data.photos].filter((el, i) => {
                    if (el.systemtype === "configfiles") {
                        return el
                    }
                })
            }
            //console.info("data.configfiles=>",data.configfiles)
            let docDefinition = {}
            const content = []
            Object.keys(data).forEach(async section => {
                data[section].map(item => {
                    delete item.transactionid
                    return item
                })
                let pageBr = "none"
                if (section === "hardwarefab" || section === "photos") {
                    pageBr = "before"
                }
                content.push({
                    text: headerMapping[section], bold: true, margin: [5, 2, 10, 2], fontSize: 16,
                    pageBreak: pageBr
                })
                content.push({
                    text: ""
                })
                if (section === "general" || section === "transaction") {
                    const rows = []
                    const record = data[section][0]

                    Object.keys(record).forEach(row => {
                        rows.push([{ text: rowMapping[row], fillColor: "", color: "", bold: true }, record[row]])
                    })
                    content.push({
                        table: {
                            widths: [200, 200],
                            body: rows
                        },
                        margin: [5, 30, 5, 30]
                    })
                }
                else if (section === "hardwarefab" || section === "hardwaresubfab" || section === "missingparts" || section === "faultyparts") {
                    const rows = []
                    const header = data[section][0]
                    let headerValues = Object.keys(header).map(element => {
                        let obj = {
                            text: rowMapping[element],
                            fillColor: "silver",
                            bold: true,
                            alignment: 'center'
                        }
                        return obj
                    })
                    //rows.push(Object.keys(headerValues))
                    rows.push(headerValues)
                    //console.log("data[section]==>",data[section])
                    data[section].forEach(row => {
                        //rows.push(Object.values(row).map(val=>(val==="" || val== undefined || val == null) ? "NONE" : val))
                        rows.push(Object.values(row))
                    })
                    content.push({
                        table: {
                            headerRows: 1,
                            body: rows,
                            widths: [100, 200, 100, 100]
                        },
                        margin: [5, 30, 5, 30]
                    })
                }
                else if (section === "photos") {
                    for (let row of data[section]) {
                        let headers = []
                        headers = Object.values(row).splice(0, 2);
                        headers[0] = rowMapping[Object.values(row).splice(0, 2)[0]]
                        if (row.systemtype !== "configfiles" && row.systemtype !== "missingparts") {
                            content.push({
                                table: {
                                    body: [headers],
                                    widths: [200, 200]
                                },
                                margin: [5, 2, 10, 2]
                            })
                            if (row.toolpicture !== undefined && row.toolpicture !== null) {
                                content.push({
                                    image: "data:" + row.mimetype + ";base64," + arraybuffbase64.encode(row.toolpicture.data),
                                    pageBreak: 'after',
                                    width: 500,
                                    maxHeight: 700
                                })
                            }
                            else {
                                content.push({
                                    text: "No Picture", italic: true
                                })
                            }
                        }
                    }
                }
                else if (section === "configfiles") {
                    for (let row of data[section]) {
                        if (row.mimetype && row.toolpicture) {
                            if (row.toolfilename.indexOf(".xl") !== -1) {
                                const xlData = xlsx.read(arraybuffbase64.encode(row.toolpicture.data), { type: 'base64' })
                                const xlTransformed = xlsx.utils.sheet_to_json(xlData.Sheets[xlData.SheetNames[0]], { header: 1 })
                                if (xlTransformed instanceof Array) {
                                    const configData = []
                                    let max = 0
                                    xlTransformed.forEach(row => {
                                        if (row.length > 0) {
                                            if (row.length > max) {
                                                max = row.length
                                            }
                                        }
                                    })
                                    xlTransformed.forEach(row => {
                                        const pdfRow = []
                                        if (row.length > 0) {
                                            for (let i = 0; i < max; i++) {
                                                if (row[i]) {
                                                    pdfRow.push({
                                                        text: row[i],
                                                        fontSize: 10
                                                    })
                                                }
                                                else {
                                                    pdfRow.push(" ")
                                                }
                                            }
                                            configData.push(pdfRow)
                                        }
                                    })
                                    content.push({
                                        table: {
                                            body: configData
                                        }
                                    })
                                }
                            }
                            else if (row.toolfilename.indexOf(".pdf") !== -1 && row.toolpicture.data) {
                                buffList.push(Buffer.from(row.toolpicture.data));
                                //console.log("config pdf buffer added")
                            }
                        }
                    }
                }
            })
            docDefinition = { content }
            //var pdf = pdfmake.createPdf(docDefinition).download();
            var pdf = pdfmake.createPdf(docDefinition);
            pdf.getBuffer(async buff => {
                //console.log('buff==>',buff)
                buffList.push(buff)
                const mergedPdf = await PDFDocument.create()
                // Load a PDFDocument from each of the existing PDFs
                for (const buff of buffList.reverse()) {
                    let loadedPdf = await PDFDocument.load(buff)
                    const copiedPages = await mergedPdf.copyPages(loadedPdf, loadedPdf.getPageIndices());
                    copiedPages.forEach((page) => mergedPdf.addPage(page));
                }
                const mergedPdfFile = await mergedPdf.save();
                //console.log("mergedPdfFile==>",mergedPdfFile)                    
                const url = window.URL.createObjectURL(new Blob([new Uint8Array(mergedPdfFile)]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.toolid}_Internal.pdf`);
                document.body.appendChild(link);
                link.click();
            })
            console.log("end")
            this.setState({ loading: false })
        }
        catch (err) {
            console.log("error==> ", err)
            const reqBody = {
                level: "error",
                message: "Error in exporting pdf. error: " + err
            }
            axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );
            this.setState({
                error: true,
                errorMsg: errorConstants.getrequestfailed,
                loading: false
            })
        }

    }

    exportToolSalePDF = async () => {

        // eslint-disable-next-line no-restricted-globals
        const userSelection = confirm("PDF will be downloaded. It make take a few moments if transaction has more/large files");
        //console.log("userSelection",userSelection)
        if (!userSelection) {
            return;
        }
        //console.log("not returned")

        this.setState({ loading: true })
        //delete this.state.viewDataDeails.configfiles[0].toolpicture
        //console.log("this.state.viewDataDeails=>",this.state.viewDataDeails)
        try {
            const buffList = []
            const data = this.state.viewDataDeails;
            if (data.transaction) {
                data.transaction = data.transaction.map(el => {
                    delete el.transactionid
                    delete el.approved
                    delete el.initiator
                    delete el.reviewer
                    delete el.reviewerremarks
                    delete el.transactiontype
                    delete el.date
                    delete el.txnfab
                    delete el.txnmodule
                    delete el.txnuemseqptid
                    delete el.txnuniquesutlid
                    delete el.txn_assets_mgt_status

                    return el
                })
            }
            // split config files from photos section..
            if (data.photos) {
                data.configfiles = [...data.photos].filter((el, i) => {
                    if (el.systemtype === "configfiles") {
                        return el
                    }
                })
            }
            //console.info("data.configfiles=>",data.configfiles)
            let docDefinition = {}
            const content = []
            Object.keys(data).forEach(async section => {
                data[section].map(item => {
                    delete item.transactionid
                    return item
                })
                let pageBr = "none"
                if (section === "photos") {
                    pageBr = "before"
                }
                let tmpSection = section === "missingparts" ? "missingpartsToolSale" : section === "hardwarefab" ? "hardwarefabToolSale" : section
                if (section === "faultyparts" || section === "hardwaresubfab" || section === "configfiles") {
                    return
                }
                // CHG0099515 chnaged the position of the code 
                // Need to add the block to check if the table is empty or not 

                const isMissingParts = section === "missingparts";

                const rowsData = isMissingParts && Array.isArray(data[section]) ? data[section] : [];

                const isAllBlank =
                    rowsData.length === 0 ||
                    rowsData.every(row =>
                        (row.description ?? "") === "" &&
                        (row.quantity ?? "") === ""
                    );
                // section header
                content.push({
                    text: headerMapping[tmpSection], bold: true, margin: [5, 2, 10, 2], fontSize: 16,
                    pageBreak: pageBr
                })
                content.push({
                    text: ""
                });
                if (section === "missingparts" && isAllBlank) {

                    if (isAllBlank) {
                        const defaultRow = { description: "", quantity: "" };

                        // Get headers from data if available, else fallback to default headers
                        const headers = Object.keys(rowsData[0] || defaultRow);

                        // Create the table header row
                        const headerRow = headers.map((element) => ({
                            text: element.charAt(0).toUpperCase() + element.slice(1),
                            fillColor: 'silver',
                            bold: true,
                            alignment: 'center'
                        }));

                        const rows = [];
                        rows.push(headerRow); // push header

                        // Always push a default row with "NONE" and blank
                        const noneRow = headers.map((_, index) => (index === 0 ? "NONE" : ""));
                        rows.push(noneRow);

                        // Push to PDF content
                        content.push({
                            table: {
                                headerRows: 1,
                                widths: [200, 100],
                                body: rows
                            },
                            margin: [5, 15, 5, 10]
                        });
                    }
                    //disclaimer
                    content.push({
                        text: "* List above may or may not be comprehensive. Tool is sold in \"as-is\" condition. To ensure your satisfaction, we strongly recommend making an appointment to inspect this and every tool you are interested in.",
                        frontSize: 8,
                        margin: [0, 4, 0, 4],
                        italics: true,
                        color: "black"
                    });
                    return;
                }

                if (section === "general" || section === "transaction") {
                    const rows = []
                    const record = data[section][0]

                    Object.keys(record).forEach(row => {
                        rows.push([{ text: rowMapping[row], fillColor: "", color: "", bold: true }, record[row]])
                    })
                    content.push({
                        table: {
                            widths: [200, 200],
                            body: rows
                        },
                        margin: [5, 30, 5, 30]
                    })
                }
                // generic tables (skip missing parts when all blan )
                else if (section === "hardwarefab" || section === "hardwaresubfab1" || section === "missingparts" || section === "faultyparts1") {

                    const rows = []
                    const header = data[section][0] === null || data[section][0] === undefined ? [] : data[section][0]
                    // get the key names (excluding 'status')
                    const headerKeys = Object.keys(header).filter(key => key.toLowerCase() !== "status");
                    //Build and push styled header row 
                    rows.push(
                        headerKeys.map(key => ({
                            text: rowMapping[key],
                            fillColor: "silver",
                            bold: true,
                            alignment: 'center'
                        }))
                    );
                    // for each data row , push only filtered  values 
                    const filteredRows =
                        (section === "missingparts" || section === "faultyparts1")
                            ? data[section].filter(row =>
                                !(
                                    (row.description ?? "") === "" &&
                                    (row.quantity ?? "") === ""
                                )
                            )
                            : data[section];
                            filteredRows.forEach(row => {
                        rows.push(
                            headerKeys.map(key => {
                                const val = row[key];
                                return val ?? '';
                            })
                        );
                    });
                    content.push({
                        table: {
                            headerRows: 1,
                            body: rows,
                            widths: [100, 200, 100, 100]
                        },
                        margin: [5, 30, 5, 30]
                    })
                    //missing parts


                }
                else if (section === "photos") {
                    for (let row of data[section]) {
                        let headers = []
                        headers = Object.values(row).splice(0, 2);
                        headers[0] = rowMapping[Object.values(row).splice(0, 2)[0]]
                        if (row.systemtype !== "configfiles" && row.systemtype !== "hardwaresubfab" && row.systemtype !== "missingparts" && row.systemtype !== "faultyparts") {
                            content.push({
                                table: {
                                    body: [headers],
                                    widths: [200, 200]
                                },
                                margin: [5, 2, 10, 2]
                            })
                            if (row.toolpicture !== undefined && row.toolpicture !== null) {
                                content.push({
                                    image: "data:" + row.mimetype + ";base64," + arraybuffbase64.encode(row.toolpicture.data),
                                    pageBreak: 'after',
                                    width: 500,
                                    maxHeight: 700
                                })
                            }
                            else {
                                content.push({
                                    text: "No Picture", italic: true
                                })
                            }
                        }
                    }
                }
                else if (section === "configfiles") {
                    for (let row of data[section]) {
                        if (row.mimetype && row.toolpicture) {
                            if (row.toolfilename.indexOf(".xl") !== -1) {
                                const xlData = xlsx.read(arraybuffbase64.encode(row.toolpicture.data), { type: 'base64' })
                                const xlTransformed = xlsx.utils.sheet_to_json(xlData.Sheets[xlData.SheetNames[0]], { header: 1 })
                                if (xlTransformed instanceof Array) {
                                    const configData = []
                                    let max = 0
                                    xlTransformed.forEach(row => {
                                        if (row.length > 0) {
                                            if (row.length > max) {
                                                max = row.length
                                            }
                                        }
                                    })
                                    xlTransformed.forEach(row => {
                                        const pdfRow = []
                                        if (row.length > 0) {
                                            for (let i = 0; i < max; i++) {
                                                if (row[i]) {
                                                    pdfRow.push({
                                                        text: row[i],
                                                        fontSize: 10
                                                    })
                                                }
                                                else {
                                                    pdfRow.push(" ")
                                                }
                                            }
                                            configData.push(pdfRow)
                                        }
                                    })
                                    content.push({
                                        table: {
                                            body: configData
                                        }
                                    })
                                }
                            }
                            else if (row.toolfilename.indexOf(".pdf") !== -1 && row.toolpicture.data) {
                                buffList.push(Buffer.from(row.toolpicture.data));
                                //console.log("config pdf buffer added")
                            }
                        }
                    }
                }
            })
            docDefinition = { content }
            //var pdf = pdfmake.createPdf(docDefinition).download();
            var pdf = pdfmake.createPdf(docDefinition);
            pdf.getBuffer(async buff => {
                //console.log('buff==>',buff)
                buffList.push(buff)
                const mergedPdf = await PDFDocument.create()
                // Load a PDFDocument from each of the existing PDFs
                for (const buff of buffList.reverse()) {
                    let loadedPdf = await PDFDocument.load(buff)
                    const copiedPages = await mergedPdf.copyPages(loadedPdf, loadedPdf.getPageIndices());
                    copiedPages.forEach((page) => mergedPdf.addPage(page));
                }
                const mergedPdfFile = await mergedPdf.save();
                //console.log("mergedPdfFile==>",mergedPdfFile)                    
                const url = window.URL.createObjectURL(new Blob([new Uint8Array(mergedPdfFile)]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.toolid}_Sale.pdf`);
                document.body.appendChild(link);
                link.click();
            })
            console.log("end")
            this.setState({ loading: false })
        }
        catch (err) {
            console.log("error==> ", err)
            const reqBody = {
                level: "error",
                message: "Error in exporting pdf. error: " + err
            }
            axios.post(`${process.env.REACT_APP_REST_API_END_POINT}logtotable`,
                reqBody,
                { headers: { 'x-api-key': process.env.REACT_APP_REST_API_KEY } }
            );
            this.setState({
                error: true,
                errorMsg: errorConstants.getrequestfailed,
                loading: false
            })
        }

    }

    render() {
        return (
            <div className={"form"}>
                <LoadingModal open={this.state.loading} msg="Loading..." />
                <Alert color="danger" isOpen={this.state.error}>{this.state.errorMsg}</Alert>
                <div style={{ textAlign: "left", marginTop: "-1%", marginLeft: "2.5%" }}>
                    <div style={{ textAlign: "left", marginLeft: "2%", marginRight: "2.5%", marginBottom: "2%", }}>
                        <Row form style={{ justifyContent: "flex-end" }}>
                            <Col md="auto">
                                <ToolSalesButton path="/toolsalesform" onClick={this.exportToolSalePDF} disabled={this.state.loading}>
                                    <AiFillFilePdf style={{ fontSize: "20px" }} />&nbsp;&nbsp;Tool Sale
                                </ToolSalesButton>
                            </Col>
                            <Col md="auto">
                                <ToolSalesButton path="/toolsalesform" onClick={this.exportPDF} disabled={this.state.loading}>
                                    <AiFillFilePdf style={{ fontSize: "20px" }} />&nbsp;&nbsp;Internal Reuse
                                </ToolSalesButton>
                            </Col>
                            <Col md="auto">
                                {this.state.isReviewer == 1 && <ToolSalesButton path="/toolsalesform" onClick={() => { this.setState({ reassign: true }) }}>Reassign</ToolSalesButton>}
                            </Col>
                            <Col md="auto">
                                <BackButton path="/transactions" label="Go Back" />
                            </Col>
                        </Row>
                    </div>

                </div>
                <div id="form-data"> {this.state.items}</div>
                <Modal style={{ "width": "50%" }} isOpen={this.state.success} >
                    <ModalHeader >Success!</ModalHeader>
                    <ModalBody>
                        {successConstants.formresponsesubmitted}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.resetComponent}>OK</Button>{' '}
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.reject} toggle={() => { this.setState({ reject: false, rejectreason: false }) }} >
                    <ModalHeader >Rejection Reason</ModalHeader>
                    <ModalBody>
                        {this.state.remarks.length > 0 ? this.state.remarks : ''}
                        Please provide reason for rejection
                        <Input type="textarea" invalid={this.state.rejectreason} onBlur={this.setRejectReason} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" value="REJECTED" onClick={this.submitRejectResponse}>Reject</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.reassign} toggle={() => { this.setState({ reassign: false }) }} >
                    <ModalHeader >Reassign Transaction</ModalHeader>
                    <Alert color="danger" isOpen={this.state.reassignEmailError}>{this.state.reassignEmailError}</Alert>
                    <ModalBody>
                        User Email <Input type="email" name="usermail" onBlur={this.setReassignEmail} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" value="REASSIGN" onClick={this.submitReassign}>Assign</Button>
                    </ModalFooter>
                </Modal>
                <Modal style={{ "width": "50%" }} isOpen={this.state.reassignSuccess} >
                    <ModalHeader >Success!</ModalHeader>
                    <ModalBody>
                        {successConstants.reassigned}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.resetComponent}>OK</Button>{' '}
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}